import type { AppThemeConfigState } from "../store/appConfigSlice";
import { fetchWithAuth, safeJson } from "./helpers/api";

const themeConfigUrl = "/api/v1/config/theme";
const defaultThemeConfigUrl = "/config/theme.json";

const getDefaultThemeConfig = async (): Promise<AppThemeConfigState> => {
  const defaultThemeResponse = await fetch(defaultThemeConfigUrl, {
    cache: "no-cache",
  });
  return safeJson(defaultThemeResponse);
};

const saveThemeConfig = async (config: AppThemeConfigState) => {
  const response = await fetchWithAuth(themeConfigUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(config),
  });

  if (!response.ok) {
    console.error("Error saving theme configuration:", response.status);
  }
};

export const getThemeConfig = async (): Promise<AppThemeConfigState> => {
  const response = await fetchWithAuth(themeConfigUrl, { cache: "no-cache" });

  if (response.status === 404) {
    const defaultThemeConfig = await getDefaultThemeConfig();

    try {
      await saveThemeConfig(defaultThemeConfig);
    } catch (err) {
      console.error("Error saving theme configuration:", err);
    }

    return defaultThemeConfig;
  }

  // Habrá que notificar al usuario de que hay un problema de nuestro lado, cargamos theme por defecto
  if (response.status === 500) {
    return getDefaultThemeConfig();
  }

  return safeJson(response);
};
